"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const country_entity_1 = require("./country.entity");
let Currency = class Currency {
    constructor(id, name, value, description, countryId, createdBy, updatedBy) {
        this.id = id;
        this.name = name;
        this.value = value;
        this.description = description;
        this.countryId = countryId;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.Currency = Currency;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], Currency.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], Currency.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "value", type: "varchar", length: 10, nullable: false }),
    tslib_1.__metadata("design:type", String)
], Currency.prototype, "value", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Currency.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "country_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Currency.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => country_entity_1.Country, (country) => country.currencies, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: "country_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof country_entity_1.Country !== "undefined" && country_entity_1.Country) === "function" ? _a : Object)
], Currency.prototype, "country", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Currency.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Currency.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamp",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Currency.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamp",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Currency.prototype, "updatedAt", void 0);
exports.Currency = Currency = tslib_1.__decorate([
    (0, typeorm_1.Entity)("currency"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, String, Number, Number, Number])
], Currency);
